import type { IData } from 'Components/DashboardTile/TileContentMaker/components/definitions';
import { formatPartialDate } from 'Utility/date';
import { partialDateFromDate } from 'neuro-utils';

export const convertInvitesToDashData = ({
  invites,
  fm,
}: {
  invites: readonly INeuroStimulus[];
  fm: (id: string) => string;
}): IData[] => {
  const data: IData[] = [];
  for (const invite of invites) {
    data.push({
      date: formatPartialDate(partialDateFromDate(new Date(invite.timestamp))),
      title: fm('myService.inviteSentDash'),
      key: `invite-${invite.id}`,
    });
  }
  return data;
};

const isCurrentPlatformTaskList = ({ taskList, platform }: { taskList: ITaskList; platform: Platform }): boolean => {
  return true;
};

export const convertTaskListsToDashData = ({
  taskLists,
  fm,
  platform,
}: {
  taskLists: readonly ITaskList[];
  fm: (id: string) => string;
  platform: Platform;
}): IData[] => {
  const data: IData[] = [];
  for (const taskList of taskLists) {
    if (isCurrentPlatformTaskList({ taskList, platform })) {
      data.push({
        date: undefined,
        title: `${fm('myService.taskList')}: ${taskList.template_id}`,
        key: taskList.id,
      });
    }
  }
  return data;
};
